<template>
  <PageTemplate>
  <div class="in-content-warpper">
    <div class="row">
      <div class="des">
        <div class="title">
          安全门 型号：H418
        </div>
        <el-row style="height:30px"></el-row>
        <p>RFID图书馆安全监测门可对粘贴有RFID标签的流通资料进行扫描、安全识别的系统设备，用于对流通资料或物品的进行安全控制，以达到防盗和监控的目的。该系统设备通过对流通资料的借阅状态的判断来确定报警提示信息是否鸣响。对粘贴有RFID标签的流通资料或物品进行安全扫描操作，不会损坏粘贴在流通资料或物品中的磁性介质的资料。</p>
        <el-row style="height:10px"></el-row>
        <p>技术参数：</p>
        <el-row style="height:10px"></el-row>
        <p>1.工作频率：13.56MHz；</p>
        <el-row style="height:10px"></el-row>
        <p>2.符合ISO15693标准、ISO18000-3标准；</p>
        <el-row style="height:10px"></el-row>
        <p>3.响应时间：≥20个标签/秒；</p>
        <el-row style="height:10px"></el-row>
        <p>4.根据学校实际测量，检测宽度：单通道≥90CM ；</p>
        <el-row style="height:10px"></el-row>
        <p>5.具有高侦测性能，能够进行三维监测；</p>
        <el-row style="height:10px"></el-row>
        <p>6.对心脏起搏器或其它医学设备无害；</p>
        <el-row style="height:10px"></el-row>
        <p>7.系统兼容AFI报警模式和EAS报警模式。</p>
      </div>
      <div class="img">
        <el-image :src="url4" fit="contain"></el-image>
      </div>
    </div>
  </div>
  </PageTemplate>
</template>
<script>
import PageTemplate from '@/components/PageTemplate'
export default {
  components:{PageTemplate},
  name: 'GuanLi',
  data () {
    return {
      url4: require('../assets/20220822_4.png')
    }
  },
  created () {
  },
  beforeDestroy () {
  }
}
</script>
<style lang="scss">
  .in-content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    .row {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      align-items: center;
      .img {
        width: 500px;
        height: 340px;
        // background-color: #f2f2f2;
        .el-image {
          width: 500px;
          height: 340px;
        }
      }
      .des {
        width: 600px;
        text-align: left;
        margin-left: 100px;
        padding-top: 1;
        line-height: 1.2;
        .title{
          font-size: 25px;
          font-weight: 600;
          color: #000;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/4.vue